import React from 'react';
import './speech-tracker.css';
import classNames from 'classnames';
import { IconButton } from '../../../../components/icon-button';
import { Icon } from '../../../../components/icon';
import { Paragraph } from '../../../../components/paragraph';

const SpeechTracker = props => {
    const {
        userSpeech,
        activeSpeechStep,
        setActiveSpeechStep,
        submitResponse,
        audioArrayNull,
        toggleAudioPlaying,
        audioPlaying,
        audioAvailable,
    } = props;

    const allOptionsNotSelected = Object.values(userSpeech).some(
        step => step === null,
    );

    const editSelection = (selection, index) => {
        setActiveSpeechStep(index);
    };

    return (
        <div className="speech-tracker">
            {audioAvailable && (
                <div className="speech-tracker__button-container">
                    <Paragraph withSpacing={false} colorScheme="dark">
                        Hear Speech
                    </Paragraph>
                    <IconButton
                        onClick={() => toggleAudioPlaying()}
                        iconName={audioPlaying ? 'stop' : 'play'}
                        size="small"
                        isDisabled={audioArrayNull}
                        altText={audioPlaying ? 'stop speech' : 'hear speech'}
                    />
                </div>
            )}
            <div
                className="speech-tracker__tracker"
                aria-label="Speech Tracker"
            >
                {Object.keys(userSpeech).map((selection, i) => {
                    const speechStepContainerClasses = classNames({
                        'speech-tracker__step-container': true,
                        'speech-tracker__step-container--border':
                            (i === 0) | (i === 3),
                    });

                    const speechStepClasses = classNames({
                        'speech-tracker__speech-step': true,
                        'speech-tracker__speech-step--active':
                            i === activeSpeechStep,
                    });

                    return (
                        <div
                            className={speechStepContainerClasses}
                            key={selection}
                            aria-label={`Speech Segment ${i + 1}`}
                        >
                            <div className="speech-tracker__step-heading">
                                <Paragraph
                                    withSpacing={false}
                                    colorScheme="dark"
                                >
                                    {i === 0
                                        ? 'Open'
                                        : i === 2
                                        ? 'Middle'
                                        : i === 4
                                        ? 'Close'
                                        : null}
                                </Paragraph>
                            </div>
                            <div className={speechStepClasses} key={selection}>
                                {userSpeech[selection] !== null ? (
                                    <>
                                        {i !== activeSpeechStep && (
                                            <IconButton
                                                iconName="edit"
                                                onClick={() => {
                                                    if (audioPlaying) {
                                                        toggleAudioPlaying();
                                                    }
                                                    editSelection(selection, i);
                                                }}
                                            />
                                        )}
                                        <Icon
                                            iconName="debate"
                                            colorScheme="dark"
                                        />
                                    </>
                                ) : null}
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="speech-tracker__button-container">
                <Paragraph withSpacing={false} colorScheme="dark">
                    Submit
                </Paragraph>
                <IconButton
                    onClick={() => submitResponse()}
                    iconName="submit"
                    size="small"
                    isDisabled={allOptionsNotSelected}
                />
            </div>
        </div>
    );
};

export { SpeechTracker };
